import React from 'react';
import { AttachMediaModal } from '../../../components/AttachMediaModal';
import { ElementWrapper } from '../../../components/ElementWrapper';
import { IElement } from '../../../models/Element';
import { ContactsImageLeftDescriptionContent } from './ContactsImageLeftDescriptionContent';
import { ContactsImageLeftDescriptionElement } from './ContactsImageLeftDescriptionElement';
import { ContactsImageLeftDescriptionFigure } from './ContactsImageLeftDescriptionFigure';

interface ContactsImageLeftDescriptionProps {
  index: number;
  data: ContactsImageLeftDescriptionElement;
  updateData: (element: IElement, index: number) => void;
}

export const ContactsImageLeftDescriptionFC: React.FC<
  ContactsImageLeftDescriptionProps
> = ({ index, data, updateData }) => {
  const update = (
    fieldsToUpdate: Partial<ContactsImageLeftDescriptionElement>
  ) => {
    const updatedData = { ...data, ...fieldsToUpdate };
    updateData(updatedData, index);
  };

  return (
    <>
      <AttachMediaModal
        modalId={`${data.name}-${data.id}`}
        updateCallback={(image, image_alt) =>
          update({ image_preview: image, image_preview_alt: image_alt })
        }
      />

      <ElementWrapper elementIndex={index}>
        <div className="contacts-image-left-description">
          <div className="position-relative align-items-center showcase">
            <ContactsImageLeftDescriptionContent data={data} update={update} />
            <ContactsImageLeftDescriptionFigure data={data} update={update} />
          </div>
        </div>
      </ElementWrapper>
    </>
  );
};
